const WarningOrangeIcon = () => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
    >
      <rect width='20' height='20' rx='10' fill='white' />
      <path
        d='M9.99935 18.3334C5.39685 18.3334 1.66602 14.6026 1.66602 10.0001C1.66602 5.39758 5.39685 1.66675 9.99935 1.66675C14.6018 1.66675 18.3327 5.39758 18.3327 10.0001C18.3327 14.6026 14.6018 18.3334 9.99935 18.3334ZM9.16602 12.5001V14.1667H10.8327V12.5001H9.16602ZM9.16602 5.83342V10.8334H10.8327V5.83342H9.16602Z'
        fill='#FF910A'
      />
    </svg>
  );
};

WarningOrangeIcon.displayName = 'WarningOrangeIcon';

export default WarningOrangeIcon;
